import H2 from "@/atoms/text/H2";
import H3 from "@/atoms/text/H3";
import Image from "@/atoms/Image";
import Label from "@/atoms/text/Label";
import Para from "@/atoms/text/Para";
import { loadDynamicIcon } from "@/utils/functions";

export default function ServicesSectionTwocol({
  label,
  bgColor = "white",
  title,
  subText,
  listData,
  image,
  contentData,
  hasTopAudioBannerLP = false,
}) {
  return (
    <section
      className={`bc-${bgColor} ${
        hasTopAudioBannerLP ? "pt-10-d pb-15-d pt-8 pb-8" : "pv-15-d pv-8"
      } ps-r`}
    >
      <div className="container">
        <div className={`fx fx--c fx--r-d fx--sb ${image ? "mb-6" : ""}`}>
          <article className="services-content mr-10-d mb-reset-d mb-6 fx-d fx--c fx--sb">
            <div>
              {label && (
                <Label size="lg" color="blue-light" className="bold mb-3">
                  {label}
                </Label>
              )}
              {title && (
                <H2
                  className="bold mb-8-d mb-3"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              )}
            </div>
            {subText && (
              <Para
                desktopSize="lg"
                mobileSize="lg"
                dangerouslySetInnerHTML={{ __html: subText }}
              />
            )}
          </article>
          {listData && (
            <ul className="ps-r w-70-d fx-d fx--w fx--sb">
              {listData.map(({ icon, title, context }, idx) => {
                const DynamicComponent = icon ? loadDynamicIcon(icon) : null;
                return (
                  <li key={idx} className="w-50-d inset-both-sm mb-1 pt-5 pb-5">
                    <div className="fx mb-2">
                      {icon && (
                        <DynamicComponent
                          width="30"
                          height="30"
                          className="icon mr-2"
                        />
                      )}
                      {title && (
                        <H3
                          className="bold"
                          desktopSize="xxs"
                          mobileSize="xxs"
                          dangerouslySetInnerHTML={{ __html: title }}
                        />
                      )}
                    </div>
                    <Para
                      mobileSize="md"
                      dangerouslySetInnerHTML={{ __html: context }}
                    />
                  </li>
                );
              })}
            </ul>
          )}
        </div>
        {image && (
          <Image
            fileName={image.fileName}
            fileFormat="png"
            desktopWidth={image.desktopWidth}
            mobileWidth={image.mobileWidth}
            mobileHeight={image.mobileHeight}
            alt={image.altText}
            className={`w-100 ${contentData ? "mb-8-d mb-6" : ""}`}
          />
        )}
        {contentData && (
          <div className="fx fx--c fx--r-d fx--cv-d fx--sb">
            <H2
              className="bold w-50-d mr-10-d mb-reset-d mb-3"
              dangerouslySetInnerHTML={{ __html: contentData.title }}
            />
            <div className="w-50-d">
              {contentData.text?.map((text, idx) => (
                <Para
                  key={idx}
                  className={idx === contentData.text.length - 1 ? "" : "mb-5"}
                  desktopSize="lg"
                  mobileSize="lg"
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              ))}
            </div>
          </div>
        )}
      </div>
      <style jsx>{`
        @media (min-width: 1200px) {
          .services-content {
            max-width: 336px;
            max-height: 420px;
          }
        }
      `}</style>
    </section>
  );
}
